import { render, staticRenderFns } from "./ResellerServicesDialog.vue?vue&type=template&id=22b60a8d&"
import script from "./ResellerServicesDialog.vue?vue&type=script&lang=js&"
export * from "./ResellerServicesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports